import React, { StrictMode } from "react";
import ReactDOM from 'react-dom/client';
import "bootstrap/dist/css/bootstrap.min.css";
import reportWebVitals from "./reportWebVitals";
import RouterProject from "./router";
//import { UserInformation } from "./context/appContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
/* Added Context
 root.render(
    <UserInformation>
        <StrictMode>
            <RouterProject />
        </StrictMode>
    </UserInformation>
); */
root.render(
    <StrictMode>
        <RouterProject />
    </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
